import React, {Component} from 'react'
import {connect} from 'react-redux'
import ReactPageScroller from 'react-page-scroller';
import {Transition} from 'semantic-ui-react'
import {loadResourcesAbout} from '../utils/homeUtils'

import {setMenuVisible} from '../actions'

import MenuIconDesktop from "../components/MenuIconDesktop";
import About1 from './About1'
import Producer from './Producer'
import styles from './About.module.scss'
import http from "../utils/http-common";

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            steps: [false, false],
            isPageVisible: false,
            language: "",
            currentPage: 0,
            toPageNumber: 0,
            titles: ["About", "Producer"],
            scrollTos: [
                "監製 / 製片人介紹",
                "邊境映象介紹"
            ],
            about: {
                id: "",
                language: "",
                producerPic: "",
                aboutDescription: "",
                producerName: "",
                producerDescription: "",
                aboutPageName: "",
                producerPageName: "",
            }
        }

        this.togglePageScroll = this.togglePageScroll.bind(this);
        this.setStepVisible = this.setStepVisible.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
    }

    componentDidMount() {
        loadResourcesAbout();
        this.getLanguage();

        setTimeout(() => {
            this.setState({
                isPageVisible: true,
            });
        }, 0);
    }

    getLanguage() {
        http.get("/api/v1/about" + "?language=" + localStorage.getItem("language"))
            .then(res=>{
                this.setState({
                    about: res.data,
                    scrollTos: [
                        res.data.producerPageName,
                        res.data.aboutPageName
                    ]});
            })
            .catch(error=>{console.log(error)})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.getLanguage();
        }
    }

    setStepVisible(index, visible) {
        const steps = [...this.state.steps];
        steps[index] = visible;
        this.setState({steps: steps});
    }

    handlePageOnChange = number => {
        this.setState({currentPage: number});
    }

    togglePageScroll() {
        this.setState({toPageNumber: ((this.state.currentPage + 1) % 2)});
    }

    render() {
        let language = this.state.language;
        return (
            <>
                <div className={`${styles.about} ${styles.desktop}`}>
                    {/* <div className={styles.background_wrapper}></div> */}
                        <>
                            <Transition visible={this.state.isPageVisible} animation='fade' duration={1000}>
                                <MenuIconDesktop />
                            </Transition>
                            <Transition visible={this.state.isPageVisible} animation='fade' duration={1000} onShow={()=>{this.setStepVisible(0, true)}}>
                            <div className={styles.page_display}>
                                <div className={`${styles.page_block} ${styles.active}`}></div>
                                <div className={`${styles.page_block}`}></div>
                            </div>
                            </Transition>
                            <Transition visible={this.state.steps[0]} animation='fade'duration={1000}>
                            <div className={styles.title}>
                                <div className={styles.title_word}>{this.state.titles[this.state.currentPage]}</div>
                                <div className={styles.subtitle_block}>
                                    <div className={styles.subtitle_word}>OUTLAND Film Production</div>
                                    <div className={styles.subtitle_line}></div>
                                    <div className={styles.subtitle_arrow_block} onClick={this.scrollToProducer}>
                                        <div className={`arrow right ${styles.arrow} ${styles.left}`}></div>
                                        <div className={`arrow right ${styles.arrow} ${styles.right}`}></div>
                                    </div>
                                    <div className={styles.subtitle_description}
                                         onClick={this.togglePageScroll}>{this.state.scrollTos[this.state.currentPage]}</div>
                                </div>
                            </div>
                            </Transition>
                            <div className={styles.content}>
                                <div className={styles.content_overlay}></div>
                            </div>
                        </>

                    {/* <Transition visible={this.props.isPageVisible} animation='fade' duration={500} */}
                                {/* onShow={this.bindScroller}> */}
                        <div className={styles.page_wrapper}>
                            <ReactPageScroller customPageNumber={this.state.toPageNumber} containerWidth="100%" transitionTimingFunction={""}
                                               containerHeight="100%" pageOnChange={this.handlePageOnChange}>
                                <About1 about={this.state.about} language={this.props.language}/>
                                <Producer about={this.state.about} language={this.props.language}/>
                            </ReactPageScroller>
                        </div>
                    {/* </Transition> */}
                </div>

                <div className={`${styles.about} ${styles.mobile}`}>
                    <div className={styles.menu_wrapper}>
                        <div className={styles.menu} onClick={() => {
                            this.props.setMenuVisible(true)
                        }}>
                            <span className={styles.menu_icon}><div className={styles.menu_icon_line}></div></span>
                            <span className="vertical_center">OUTLAND Film Production</span>
                        </div>
                    </div>
                    <div className={styles.page_wrapper}>
                        <div className={styles.content_container}>
                            <About1 about={this.state.about} language={this.props.language}/>
                            <Producer about={this.state.about} language={this.props.language}/>
                        </div>
                    </div>

                </div>
            </>
        );
    }

};

const mapStateToProps = state => {
    return {
        isPageVisible: state.isPageVisible,
        language: state.language
    };
};

export default connect(mapStateToProps, {setMenuVisible})(About);
